import React from 'react'
import SystemLabelMasterCollection from 'collections/system_label_master_collection'

const SelectBed = (props) => {

  const handleChange = (e) => {
    props.actions.changeSelectBed({
      selectBed: e.target.value,
    })
  }

  const {  payload } = props.systemLabelMastersApi
  if (!payload) {return null}
  const systemLabelMasterCollection = new SystemLabelMasterCollection(payload)
  const {selectBed} = props
  return (
    <div className='searchArea__item'>
      <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.LIST_SEARCH.BED}</h3>
      <p className='radio radio__bed searchArea__item__inner'>
        <input
          className='radio'
          checked={selectBed == ''}
          type='radio'
          name='select_bed'
          value=''
          id='bed_all'
          onChange={handleChange}
        />

        {
          systemLabelMasterCollection.getValueList('item','bed_space').map(i => {
            return(
              <React.Fragment key={i.get('label_key')}>
                <input
                  className='radio'
                  checked={i.get('label_key')==selectBed}
                  type='radio'
                  name='select_bed'
                  value={i.get('label_key')}
                  id={i.get('label_key')}
                  onChange={handleChange}
                />
                <label htmlFor={i.get('label_key')}>{i.getValueI18n()}</label>
              </React.Fragment>
            )
          })
        }
      </p>
    </div>
  )
}
export default SelectBed;